import { EcertMelding, MeldingType, StatusOptions } from '@models';
import { isEmptyValue } from '@helpers';
import { EcertMeldingService } from '../ecert-melding.service';

import * as $ from 'jquery';

export interface DialogContent {
  content: StatusOptions;
  state: string;
  isPopup?: boolean;
}

export class HttpWrapperDialogs {
  constructor(private eCertMeldingService: EcertMeldingService) {}

  createErrorDialog(content: DialogContent, bestemming?: string): void {
    this.customError(content.content.errorText, content.isPopup, bestemming);
    // USEC-6247: door deze aanroep via CustomError scrollt het scherm hiervoor nu ook naar boven
  }

  customError(melding: string, isPopup?: boolean, bestemming?: string): void {
    this.customErrorWithCustomHeader('Er is een fout opgetreden', melding, isPopup, bestemming);
  }

  customErrorMetBestand(header: string, melding: string, isPopup?: boolean, bestemming?: string, bestand?: string): void {
    const error = { header: 'Er is een fout opgetreden', melding: melding, type: MeldingType.ERROR, isPopup: isPopup };
    this.voegMeldingMetBestandToe(error, bestemming, bestand);
  }

  customErrorWithCustomHeader(header: string, melding: string, isPopup?: boolean, bestemming?: string): void {
    const error = { header: header, melding: melding, type: MeldingType.ERROR, isPopup: isPopup };
    this.voegMeldingToe(error, bestemming);
  }

  customSuccess(melding: string, isPopup?: boolean, bestemming?: string): void {
    const success = { header: '', melding, type: MeldingType.SUCCES, isPopup };
    this.voegMeldingToe(success, bestemming);
  }

  private voegMeldingToe(content: EcertMelding, bestemming?: string): void {
    if (!isEmptyValue(bestemming)) {
      content = { ...content, bestemming };
    }
    $('html,body').animate({ scrollTop: 0 }, 500);
    this.eCertMeldingService.voegMeldingToe(content);
  }

  removeError(): void {
    this.eCertMeldingService.voegMeldingToe(null);
  }

  private voegMeldingMetBestandToe(content: EcertMelding, bestemming?: string, bestand?: string): void {
    if (!isEmptyValue(bestemming)) {
      content = { ...content, bestemming };
    }
    $('html,body').animate({ scrollTop: 0 }, 500);
    content.bestand = bestand;
    this.eCertMeldingService.voegMeldingToe(content);
  }
}
